import mitt, { type Emitter } from 'mitt'

interface CustomEvent extends Record<string | symbol, unknown> {
  requestLogin: void
  openReportForm: { resourceId: number; resourceType: ResourceType }
  openForwardForm: { resourceId: number; resourceType: ResourceType }
  openRewardForm: { resourceId: number; resourceType: ResourceType }
  openFavoriteForm: { resourceId: number; resourceType: ResourceType }
  rewardSuccess: {
    resourceId: number
    resourceType: ResourceType
    count: number
  }
  favoriteSuccess: {
    resourceId: number
    resourceType: ResourceType
    isFavorite: boolean
  }
  openCommentDetail: { commentId: number }
  openCommentReplyInput: { commentId: number }
  openCommentReplyInputInDetailPage: { commentId: number }
}
const emitter = mitt<CustomEvent>()
export function useEmitter() {
  if (process.client) {
    return emitter
  } else {
    return {
      on: (event: keyof CustomEvent, handler: (...args: any[]) => void) => {}
    } as Emitter<CustomEvent>
  }
}
